import React, { useContext } from 'react';
import { Pagination } from 'anf-core-react';
import ProductPageContext from '../contexts/ProductPageContext';

export default function ModalPagination({
  setPage, page, totalPages,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData } = ProductPageState;
  const incrementPage = () => setPage(Math.min(page + 1, totalPages.length));
  const decrementPage = () => setPage(Math.max(1, page - 1));

  return (
    <Pagination
      className
      nextButton={{
        isDisabled: page === totalPages.length,
        labelText: 'Next',
        onClick: incrementPage,
      }}
      previousButton={{
        isDisabled: page === 1,
        labelText: 'Previous',
        onClick: decrementPage,
      }}
      variant="abbreviated"
    >
      {page}
      {' '}
      {tmntData.ofText?.value.toLowerCase()}
      {' '}
      {totalPages.length}
    </Pagination>
  );
}
